import { useEffect } from 'react';

import { useSearchParams } from '@remix-run/react';

import toast from '~/utils/toast';

const useJSDisabledSubmissionToasts = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const hasJSSubmissionError = searchParams.get('submission_error');
  const hasJSSubmissionSuccess = searchParams.get('submission_success');

  useEffect(() => {
    if (hasJSSubmissionError) {
      toast.error('There was an error submitting the form. Please reload the page and try again.');
      searchParams.delete('submission_error');
      setSearchParams(searchParams, { replace: true });
    }

    if (hasJSSubmissionSuccess) {
      toast.success('Success');
      searchParams.delete('submission_success');
      setSearchParams(searchParams, { replace: true });
    }
  }, [hasJSSubmissionError, hasJSSubmissionSuccess]);
};

export default useJSDisabledSubmissionToasts;
